import { useTranslation } from 'react-i18next'

import { useNotification } from '../../../../../../../hooks'
import { FormModalContainer, useCloseConfirm } from '../../../../../../Form'
import { FormikForm } from '../../../../../../Formik'
import {
  getListingUnitLabel,
  patchMockListingMatchRules,
} from '../../../../../../RentalPortalListing'
import {
  MATCH_RULES_SAVE_ERROR_KEY,
  QA_NAME_MATCH_RULES_MODAL,
} from '../ListingProfileApplicantsMatchRules.constants'

import { getMatchRulesInitialValues } from './ListingProfileApplicantsMatchRulesModal.utils'
import { ListingProfileApplicantsMatchRulesModalFields } from './ListingProfileApplicantsMatchRulesModalFields'

import * as styles from './ListingProfileApplicantsMatchRulesModal.module.css'

function ListingProfileApplicantsMatchRulesModal({
  listing,
  rules,
  onClose,
  onReevaluate,
}) {
  const { t } = useTranslation()

  const { handleAddErrorNotification } = useNotification()

  const { handleClose, isCloseConfirm, setCloseConfirm } = useCloseConfirm({
    onClose,
  })

  async function handleSubmit(values) {
    try {
      const response = await patchMockListingMatchRules({
        listingId: listing?.id,
        values,
      })

      onClose()

      onReevaluate({
        applicants: rules.affected_applicants_count,
        jobId: response?.data?.job_id,
      })
    } catch (error) {
      handleAddErrorNotification({
        title: t(
          MATCH_RULES_SAVE_ERROR_KEY[error?.code] ??
            'RentalPortal.MatchRulesSaveErrorKey'
        ),
      })
    }
  }

  return (
    <FormikForm
      Container={FormModalContainer}
      containerProps={{
        boxProps: { className: styles.box },
        boxSize: null,
        isCloseConfirm,
        qaName: QA_NAME_MATCH_RULES_MODAL,
        setCloseConfirm,
        title: t('RentalPortal.MatchRulesModalTitleKey', {
          listing: getListingUnitLabel({ listing, t }),
        }),
        onClose,
      }}
      initialValues={getMatchRulesInitialValues(rules)}
      onSubmit={handleSubmit}
    >
      <ListingProfileApplicantsMatchRulesModalFields
        rules={rules}
        onCancel={handleClose}
      />
    </FormikForm>
  )
}

export default ListingProfileApplicantsMatchRulesModal
